import { minBreakpoints, primaryRegularFont, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { getContentstackImageURL } from '@noths/polaris-client-utils';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
var backgroundImageWithGradient = function backgroundImageWithGradient(imgURL) {
  return css(["background-image:linear-gradient(180deg,rgba(30,30,41,0) 30%,rgba(30,30,41,0.9) 80%),url('", "');"], imgURL);
};
export var root = function root(backgroundImageUrl) {
  var backgroundImage = {
    DEFAULT: getContentstackImageURL(backgroundImageUrl, 768, {
      aspectRatio: '3:2'
    }),
    M: getContentstackImageURL(backgroundImageUrl, 1024, {
      aspectRatio: '3:2'
    }),
    L: getContentstackImageURL(backgroundImageUrl, 1440, {
      aspectRatio: '2:1'
    })
  };
  return css(["display:grid;grid-template-rows:100px auto;grid-row-gap:", "px;grid-template-areas:'logo' 'content';border-radius:", "px;padding:", "px;max-width:1440px;min-height:492px;", ";background-size:cover;background-repeat:no-repeat;background-position:center 0;color:#fff;", ";", ";"], spacing.sm, spacing.sm, spacing.xl, backgroundImageWithGradient(backgroundImage.DEFAULT), mediaQuery({
    min: minBreakpoints.M
  }, css(["grid-column-gap:", "px;min-height:368px;", ";"], spacing.sm, backgroundImageWithGradient(backgroundImage.M))), mediaQuery({
    min: minBreakpoints.L
  }, css(["min-height:385px;", ";"], backgroundImageWithGradient(backgroundImage.L))));
};
export var logo = /*#__PURE__*/css(["grid-area:logo;max-width:300px;"]);
export var content = /*#__PURE__*/css(["grid-area:content;align-self:end;p{margin:0;", ";font-size:", "px;line-height:", "px;padding:0 0 ", "px 0;", ";}"], primaryRegularFont, text.BODY.MD.fontSize, text.BODY.MD.lineHeight, spacing.xs, mediaQuery({
  min: minBreakpoints.M
}, css(["padding:0 ", "px 0 0;"], spacing.lg)));
export var heading = /*#__PURE__*/css(["margin:0 0 ", "px;", ";font-size:", "px;line-height:", "px;"], spacing.xs, primarySemiBoldFont, text.HEADING.LG.fontSize, text.HEADING.LG.lineHeight);
export var body = /*#__PURE__*/css(["display:flex;flex-direction:column;justify-content:space-between;", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["flex-direction:row;"])));
export var button = /*#__PURE__*/css(["", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["max-width:280px;min-width:200px;align-self:end;"])));